import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const BpayText = () => (_jsx(_Fragment, { children: _jsxs("span", { children: ["B", _jsxs("span", { className: "bpay", children: ["PAY", _jsx("span", { className: "registered", children: "\u00AE" })] })] }) }));
export default BpayText;
